import SideBar from "./sidebar";
import FullScreenLayout from "./full-screen-layout";
import MainMenuItems from "./main-menu-items";
import NavMenuItems from "./nav-menu-items";
import MainBodyLayout from "./main-body-layout";
import { BusinessProvider } from "/contexts/business-context";
import { UserProvider } from "/contexts/user-context";
import { SideBarProvider } from "../../contexts/side-bar-context";
import { MailProvider } from "../../contexts/mail-context";
import Loader from "../ui/loader";
import BottomNav from "./bottom-nav";
import MailMenuItems from "./mail-menu-items";
import Notification from "../ui/notification";
import { ThemeProvider } from "next-themes"
import { TableMailProvider } from "../../contexts/table-mail-context";
import { DomainProvider } from "../../contexts/domain-context";
import { SearchableInputProvider } from "../../contexts/searchable-input-context";
import { ContactProvider } from "../../contexts/contact-context";
import { InstalledPegsProvider } from "../../contexts/installed-pegs-context";

export default function Shell({ children }) {

  return (
    <>
      <div id="modal-root">
        <UserProvider>
          <BusinessProvider>
            <Loader>
              {/* <InstalledPegsProvider> */}
                <SearchableInputProvider>
                  <SideBarProvider>
                    <ThemeProvider>
                      <MailProvider>
                        <DomainProvider>
                          <ContactProvider>
                            <TableMailProvider>
                              <FullScreenLayout>
                                <SideBar>
                                  <MainMenuItems>
                                    <NavMenuItems />
                                  </MainMenuItems>
                                  <BottomNav />
                                </SideBar>
                                <MainBodyLayout>
                                  {children}
                                </MainBodyLayout>
                              </FullScreenLayout>
                            </TableMailProvider>
                          </ContactProvider>
                        </DomainProvider>
                      </MailProvider>
                    </ThemeProvider>
                  </SideBarProvider>
                </SearchableInputProvider>
              {/* </InstalledPegsProvider> */}
            </Loader>
          </BusinessProvider>
        </UserProvider>
        <Notification />
      </div>
    </>
  );
}
